export const TYPES = {
  Axios: Symbol.for("Axios"),
  Config: Symbol.for("Config"),
  BackendClient: Symbol.for("BackendClient"),
  FavoriteStore: Symbol.for("FavoriteStore"),
}
